// extracted by mini-css-extract-plugin
var _1 = "styles-module__childLink___eQe_Z";
var _2 = "styles-module__container___oRsHg";
var _3 = "styles-module__title___riLwi";
export { _1 as "childLink", _2 as "container", _3 as "title" }
